export const BuildingIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#6F6C6C"
    strokeWidth="2"
    strokeLinejoin="round"
    strokeLinecap="round"
  >
    <path d="M3 21h18" />
    <rect x="5" y="3" width="9" height="18" rx="1" />
    <rect x="14" y="9" width="6" height="12" rx="1" />
    <line x1="8" y1="7" x2="8.01" y2="7" />
    <line x1="11" y1="7" x2="11.01" y2="7" />
    <line x1="8" y1="11" x2="8.01" y2="11" />
    <line x1="11" y1="11" x2="11.01" y2="11" />
  </svg>
);
